export const isValidNumber = (number: string) => {
  return number === '' || Number(number) || Number(number) === 0
}